/** 登入頁的動態背景。
 *
 *  設計考量：
 *    - 純 CSS 動畫，不用 canvas —— 省電、切到背景會自動暫停
 *    - 三層：網格 + 呼吸光暈 + 掃描線，速度都很慢（8~20s），
 *      是氛圍不是特效，不會搶走表單的注意力
 *    - 全部尊重 prefers-reduced-motion（在 index.css 統一處理）
 */
import { cn } from '@/lib/utils';

export function LoginBackdrop({ className }: { className?: string }) {
  return (
    <div className={cn('pointer-events-none absolute inset-0 overflow-hidden', className)}
         aria-hidden="true">
      {/* 細網格：緩慢橫移，暗示資料持續流動 */}
      <div
        className="login-grid absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)',
          backgroundSize: '56px 56px',
        }}
      />

      {/* 兩顆光暈交錯呼吸，讓深色背景不死板 */}
      <div
        className="login-glow-a absolute -left-40 -top-40 h-[34rem] w-[34rem] rounded-full blur-[110px]"
        style={{ background: 'radial-gradient(circle, rgba(185,28,28,.42), transparent 68%)' }}
      />
      <div
        className="login-glow-b absolute -bottom-52 -right-32 h-[30rem] w-[30rem] rounded-full blur-[120px]"
        style={{ background: 'radial-gradient(circle, rgba(127,29,29,.34), transparent 70%)' }}
      />

      {/* 掃描線：從上往下一道極淡的光，像監控畫面的更新 */}
      <div className="login-scan absolute inset-x-0 h-[38%]" />

      {/* 幾顆訊號點沿線飄移，代表現場節點回傳 */}
      <svg className="absolute inset-0 h-full w-full opacity-[0.28]" preserveAspectRatio="none">
        <defs>
          <linearGradient id="linefade" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#ff7781" stopOpacity="0" />
            <stop offset="50%" stopColor="#ff7781" stopOpacity="0.55" />
            <stop offset="100%" stopColor="#ff7781" stopOpacity="0" />
          </linearGradient>
        </defs>
        {[18, 46, 74].map((top, i) => (
          <g key={top}>
            <line x1="0" y1={`${top}%`} x2="100%" y2={`${top}%`}
                  stroke="url(#linefade)" strokeWidth="1" />
            <circle r="2.5" fill="#ff7781">
              <animate attributeName="cx" from="-2%" to="102%"
                       dur={`${11 + i * 4}s`} repeatCount="indefinite" />
              <animate attributeName="cy" values={`${top}%;${top}%`}
                       dur={`${11 + i * 4}s`} repeatCount="indefinite" />
              <animate attributeName="opacity" values="0;1;1;0"
                       dur={`${11 + i * 4}s`} repeatCount="indefinite" />
            </circle>
          </g>
        ))}
      </svg>
    </div>
  );
}
